/**
 * Filter an array of elements by wether they are contained within the supplied container.
 * @param {Element[] | HTMLCollection | NodeList} elements
 * @param {Element | string} container
 * @returns {Element[]}
 */
export const filterElementsByContainer = (elements, container) => {
	const containerElement = typeof container === 'string'
		? document.querySelector(container)
		: container;
	const elementsArray = Array.from(elements);

	return elementsArray.filter(element => containerElement.contains(element));
};
